import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// One-time rebrand notice for signed-in users (server decides: enabled window + per-account dismissal).
const cache = {}; // per user id — avoids refetching on every page's Navbar mount
export function BrandNoticeBanner() {
  const { user } = useAuth();
  const uid = user?.id;
  const [show, setShow] = useState(!!cache[uid]);
  useEffect(() => {
    if (!uid) return;
    if (uid in cache) { setShow(cache[uid]); return; }
    api.get("/me/brand-notice").then((r) => { cache[uid] = !!r.data?.show; setShow(cache[uid]); }).catch(() => { cache[uid] = false; });
  }, [uid]);
  if (!show) return null;
  const dismiss = () => {
    cache[uid] = false; setShow(false);
    api.post("/me/brand-notice/dismiss").catch(() => {});
  };
  return (
    <div role="status" data-testid="brand-notice-banner" className="border-b border-[#C79A3B]/30 bg-[#0B1D36] text-white">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 sm:px-6">
        <Sparkles className="h-4 w-4 shrink-0 text-[#D9B45A]" aria-hidden="true" />
        <p className="min-w-0 flex-1 text-[13px] leading-snug text-white/90" data-testid="brand-notice-text">
          <span className="font-semibold text-white">PropConnect AI is now </span>
          <span className="font-semibold text-[#D9B45A]">PropertyConnect</span>
          <span className="text-white/80"> — same account, same links, same network.</span>
        </p>
        <button type="button" onClick={dismiss} data-testid="brand-notice-dismiss"
          className="inline-flex h-8 shrink-0 items-center gap-1 rounded-full bg-[#C79A3B] px-3 text-xs font-semibold text-[#0B1D36] transition-colors hover:bg-[#D9B45A]">
          Got it <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

export default BrandNoticeBanner;
